import gql from "graphql-tag";

export const UPDATE_USER_PHONE = gql`
  mutation updateUser($phone: String!, $currentPassword: String!) {
    updateUser(phone: $phone, currentPassword: $currentPassword) {
      user {
        id
        phone
      }
      accessToken
    }
  }
`;

export const CHECK_USER_LOGIN = gql`
  query checkLogin($login: String!) {
    checkLogin(login: $login) {
      isExist
    }
  }
`;

export const CONFIRM_USER_PHONE = gql`
  mutation confirmUserPhone($phone: String!, $pin: String!) {
    confirmUserPhone(phone: $phone, pin: $pin) {
      user {
        id
        phone
      }
      accessToken
    }
  }
`;

export const RESENT_PHONE_PIN = gql`
  mutation resendConfirmationPin($phone: String!) {
    resendConfirmationPin(phone: $phone) {
      status
    }
  }
`;
